const parseDate = (date) => {
  return date.split("T")[0];
};

export default parseDate;
